import { useState } from "react";
import OperacionesCambioCuentasPorCobrar from "./OperacionesCambioCuentasPorCobrar";

function SolicitudesCuentasPorCobrar({
  datosSolicitud,
  actualizarDatosTipoSolicitud,
}) {
  const [datosSolicitudLocal, setDatosSolicitudLocal] = useState({
    operaciones: datosSolicitud.operaciones,
  });

  function actualizarOperaciones(operaciones) {
    const nuevosDatos = {
      ...datosSolicitudLocal,
      operaciones: operaciones,
    };
    actualizarDatos(nuevosDatos);
  }

  function actualizarDatos(nuevosDatos) {
    setDatosSolicitudLocal(nuevosDatos);
    actualizarDatosTipoSolicitud(nuevosDatos);
  }

  return (
    <>
      <OperacionesCambioCuentasPorCobrar
        operaciones={datosSolicitudLocal.operaciones}
        actualizarOperaciones={actualizarOperaciones}
        permiteEditar="true"
        permiteEliminar="true"
        soloLectura = "false"
      />
    </>
  );
}

export default SolicitudesCuentasPorCobrar;
